import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { getMinutesfromDate, time24ToMinutes } from '@open-tender/utils';
const initialState = {
    entities: [],
    selected: null,
    error: null,
    loading: 'idle'
};
export var DealsActionType;
(function (DealsActionType) {
    DealsActionType["FetchDeals"] = "deals/fetchDeals";
})(DealsActionType || (DealsActionType = {}));
export const fetchDeals = createAsyncThunk(DealsActionType.FetchDeals, (_, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        const { profile } = getState().customer.account;
        const { customer_id = null } = profile || {};
        return yield api.getDeals(customer_id);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const dealsSlice = createSlice({
    name: ReducerType.Deals,
    initialState,
    reducers: {
        resetDeals: () => initialState,
        setSelectedDeals: (state, action) => {
            state.selected = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchDeals.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchDeals.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchDeals.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetDeals, setSelectedDeals } = dealsSlice.actions;
export const selectDeals = (state) => state.deals;
export const selectEligibleDeals = (state) => {
    const { brand } = state.config || {};
    if (!brand || !brand.has_deals)
        return [];
    let { entities: deals } = state.deals;
    const { orderType, serviceType, revenueCenter } = state.order;
    if (orderType) {
        deals = deals.filter(i => !i.order_type || i.order_type === orderType);
    }
    if (serviceType) {
        deals = deals.filter(i => !i.service_type || i.service_type === serviceType);
    }
    if (revenueCenter) {
        const { revenue_center_id } = revenueCenter;
        deals = deals.filter(i => {
            var _a;
            return !((_a = i.revenue_centers) === null || _a === void 0 ? void 0 : _a.length) ||
                i.revenue_centers
                    .map(r => r.revenue_center_id)
                    .includes(revenue_center_id);
        });
    }
    const minutes = getMinutesfromDate(new Date());
    deals = deals.filter(i => {
        if (!i.dayparts.length)
            return true;
        const validDayparts = i.dayparts.filter(d => {
            const start = time24ToMinutes(d.start_time);
            const end = time24ToMinutes(d.end_time);
            return start <= minutes && minutes <= end;
        });
        return validDayparts.length > 0;
    });
    return deals;
};
export const dealsReducer = dealsSlice.reducer;
